import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = {
  categories: () => axios.get(`${API}/categories`).then((r) => r.data),
  products: (params = {}) => axios.get(`${API}/products`, { params }).then((r) => r.data),
  product: (slug) => axios.get(`${API}/products/${slug}`).then((r) => r.data),
  reviews: () => axios.get(`${API}/reviews`).then((r) => r.data),
  faqs: () => axios.get(`${API}/faqs`).then((r) => r.data),
  subscribe: (email) => axios.post(`${API}/newsletter`, { email }).then((r) => r.data),
  shopifyCheckout: (items) => axios.post(`${API}/checkout`, { items }).then((r) => r.data),
  authConfig: () => axios.get(`${API}/auth/config`).then((r) => r.data),
  authAuthorize: (origin) => axios.get(`${API}/auth/authorize`, { params: { origin } }).then((r) => r.data),
  authCallback: (payload) => axios.post(`${API}/auth/callback`, payload).then((r) => r.data),
  authRefresh: (payload) => axios.post(`${API}/auth/refresh`, payload).then((r) => r.data),
  authMe: (token) => axios.get(`${API}/auth/me`, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data),
  authOrder: (id, token) => axios.get(`${API}/auth/orders/${id}`, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data),
  authLogout: (idToken, origin) => axios.post(`${API}/auth/logout`, { id_token: idToken }, { params: { origin } }).then((r) => r.data),
};

export const inr = (n) => `₹${Number(n).toLocaleString("en-IN")}`;
export const money = (n, currency = "INR") =>
  currency === "INR" || !currency
    ? inr(n)
    : new Intl.NumberFormat("en-IN", { style: "currency", currency }).format(Number(n));
export const fmtDate = (iso) =>
  iso ? new Date(iso).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" }) : "";
